import React from 'react';
import { Button } from '../../../components/ui/Button';
import { Icon } from '../../../components/ui/Icon';
import { Callout } from '../../../components/ui/Callout';

interface ShipStepNavigationProps {
  onBack?: () => void;
  backLabel?: string;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  validationMessage?: string;
  isLastStep?: boolean;
}

export const ShipStepNavigation: React.FC<ShipStepNavigationProps> = ({
  onBack,
  backLabel = 'Back',
  onNext,
  nextLabel = 'Continue',
  nextDisabled = false,
  nextLoading = false,
  validationMessage,
  isLastStep = false,
}) => {
  return (
    <div style={{ marginTop: 24 }}>
      {validationMessage && (
        <div style={{ marginBottom: 12 }}>
          <Callout tone="warn">
            <Icon name="alertCircle" size={14} />
            <span style={{ fontSize: 13 }}>{validationMessage}</span>
          </Callout>
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: onBack ? 'space-between' : 'flex-end', alignItems: 'center', gap: 12 }}>
        {onBack && (
          <Button variant="ghost" size="sm" onClick={onBack}>
            <Icon name="arrowLeft" size={14} />
            <span>{backLabel}</span>
          </Button>
        )}
        {onNext && (
          <Button
            variant="blue"
            size="lg"
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
          >
            {nextLoading ? (
              <span>Processing…</span>
            ) : (
              <>
                <span>{nextLabel}</span>
                {!isLastStep && <Icon name="arrowRight" size={14} />}
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
